module.exports = __webpack_public_path__ + "static/media/cup_top_1.cfb7fa8f.webp";